import { price as priceUtil, string } from '@eti/utils';
export const SELECTBOX_VALUE = {
  ALL: 'ALL',
  NONE: 'NONE'
};
export const getTotalPrice = (options = []) => {
  if (!options.length) {
    return null;
  }
  return options.reduce((totalPrice, {
    priceRaw
  }) => totalPrice !== null && priceRaw !== undefined ? totalPrice + priceRaw : null, 0);
};
export const getMinPrice = (options = []) => {
  var _options$filter;
  const minPrice = options === null || options === void 0 || (_options$filter = options.filter(({
    priceRaw
  }) => priceRaw !== undefined)) === null || _options$filter === void 0 ? void 0 : _options$filter.reduce((total, {
    priceRaw
  }) => total && priceRaw !== undefined ? Math.min(priceRaw, total) : priceRaw || 0, null);
  return minPrice;
};
export const formatOptions = (options = [], allTravelersLabel, noTravelersLabel) => {
  return options.length ? [{
    value: SELECTBOX_VALUE.ALL,
    label: allTravelersLabel,
    id: SELECTBOX_VALUE.ALL.toLocaleLowerCase(),
    exclude: true,
    price: priceUtil.formatPrice(getTotalPrice(options) || 0)
  }, ...options.map(({
    id,
    name,
    priceRaw
  }) => ({
    value: id,
    label: name,
    priceRaw,
    price: priceUtil.formatPrice(priceRaw)
  })), {
    value: SELECTBOX_VALUE.NONE,
    label: noTravelersLabel,
    id: SELECTBOX_VALUE.NONE.toLocaleLowerCase(),
    exclude: true,
    price: priceUtil.formatPrice(0)
  }] : [];
};
export const formatLabel = ({
  selectedOptions = [],
  allTravelersLabel,
  defaultPlaceholder,
  placeholderSelectedSingular,
  placeholderSelectedPlural,
  noTravelersLabel
}) => {
  if (!(selectedOptions !== null && selectedOptions !== void 0 && selectedOptions.length)) {
    return defaultPlaceholder;
  }
  if (selectedOptions.some(option => option.value === SELECTBOX_VALUE.NONE)) {
    return noTravelersLabel;
  }
  if (selectedOptions.some(option => option.value === SELECTBOX_VALUE.ALL)) {
    return allTravelersLabel;
  }
  return selectedOptions.length === 1 ? string.insertArgument(placeholderSelectedSingular, selectedOptions.length) : string.insertArgument(placeholderSelectedPlural, selectedOptions.length);
};
export const handleSelectedOption = (allOptions, previousValues, newValues = []) => {
  const newSelectedOptions = newValues && (newValues === null || newValues === void 0 ? void 0 : newValues.filter(newValue => !(previousValues !== null && previousValues !== void 0 && previousValues.some(prevVal => (prevVal === null || prevVal === void 0 ? void 0 : prevVal.value) === newValue.value))));
  const unselectedOption = previousValues === null || previousValues === void 0 ? void 0 : previousValues.filter(prevVal => newValues && !(newValues !== null && newValues !== void 0 && newValues.find(newValue => newValue.value === prevVal.value)));

  // If new selected options are empty and there were no selected options before, return null
  if (!(newSelectedOptions !== null && newSelectedOptions !== void 0 && newSelectedOptions.length) && !(previousValues !== null && previousValues !== void 0 && previousValues.length)) {
    return undefined;
  }
  const isAllOptionsSelected = Array.isArray(newValues) && allOptions.filter(option => option.value !== SELECTBOX_VALUE.ALL && option.value !== SELECTBOX_VALUE.NONE).every(option => newValues.some(opt => opt.value === option.value));
  const noSpecialOptionsSelected = Array.isArray(newValues) && !newValues.some(option => option.value === SELECTBOX_VALUE.ALL || option.value === SELECTBOX_VALUE.NONE);

  // If "ALL" is selected, select ALL options except NONE
  if (Array.isArray(newSelectedOptions) && newSelectedOptions !== null && newSelectedOptions !== void 0 && newSelectedOptions.some(option => option.value === SELECTBOX_VALUE.ALL)) {
    return allOptions === null || allOptions === void 0 ? void 0 : allOptions.filter(option => option.value !== SELECTBOX_VALUE.NONE);
  }

  // If all options are selected except "ALL" and "NONE", select "ALL" as well and only dont select "NONE"
  if (isAllOptionsSelected && noSpecialOptionsSelected) {
    return allOptions.filter(option => option.value !== SELECTBOX_VALUE.NONE);
  }

  // If "NONE" is selected, choose only "NONE" and deselect everything else
  if (Array.isArray(newSelectedOptions) && newSelectedOptions !== null && newSelectedOptions !== void 0 && newSelectedOptions.some(option => option.value === SELECTBOX_VALUE.NONE)) {
    return allOptions === null || allOptions === void 0 ? void 0 : allOptions.filter(option => option.value === SELECTBOX_VALUE.NONE);
  }

  // If "ALL" is selected again, remain previousValues
  if (unselectedOption !== null && unselectedOption !== void 0 && unselectedOption.some(option => option.value === SELECTBOX_VALUE.ALL)) {
    return previousValues;
  }

  // If unselect an option, deselect the option and remove ALL, and NONE option
  if (unselectedOption) {
    return Array.isArray(newValues) ? newValues === null || newValues === void 0 ? void 0 : newValues.filter(newValue => newValue.value !== SELECTBOX_VALUE.ALL && newValue.value !== SELECTBOX_VALUE.NONE) : previousValues;
  }
  return newValues;
};
//# sourceMappingURL=selectBoxOptions.js.map